<h2 mat-dialog-title>{{ data.confirmType }} Action</h2>
<mat-dialog-content>
    {{ data.dialog }}
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="accent" (click)="onConfirm()">{{ data.confirmType }}</button>
</mat-dialog-actions>